/**
 * Enums para los tipos y estados de cotizaciones
 * Centraliza los valores para evitar hardcoding
 */

export enum QuoteType {
  SALE = 'sale',
  RENT = 'rent',
  LEASE = 'lease',
}

export enum QuoteStatus {
  DRAFT = 'draft',
  SENT = 'sent',
  VIEWED = 'viewed',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  CONVERTED = 'converted',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
}

export enum QuoteFilterType {
  ALL = 'all',
  SALE = 'sale',
  RENT = 'rent',
  LEASE = 'lease',
}

export enum QuoteFilterStatus {
  ALL = 'all',
  DRAFT = 'draft',
  SENT = 'sent',
  VIEWED = 'viewed',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  CONVERTED = 'converted',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
}

// Mapeo de estados a etiquetas en español
export const QuoteStatusLabels = {
  [QuoteStatus.DRAFT]: 'Borrador',
  [QuoteStatus.SENT]: 'Enviada',
  [QuoteStatus.VIEWED]: 'Vista',
  [QuoteStatus.ACCEPTED]: 'Aceptada',
  [QuoteStatus.REJECTED]: 'Rechazada',
  [QuoteStatus.EXPIRED]: 'Expirada',
  [QuoteStatus.CONVERTED]: 'Convertida',
  [QuoteStatus.PENDING]: 'Pendiente',
  [QuoteStatus.CANCELLED]: 'Cancelada',
} as const;

// Mapeo de tipos a etiquetas en español
export const QuoteTypeLabels = {
  [QuoteType.SALE]: 'Venta',
  [QuoteType.RENT]: 'Alquiler',
  [QuoteType.LEASE]: 'Arrendamiento',
} as const;

// Configuración de colores para estados
export const QuoteStatusColors = {
  [QuoteStatus.DRAFT]: 'bg-gray-100 text-gray-800',
  [QuoteStatus.SENT]: 'bg-blue-100 text-blue-800',
  [QuoteStatus.VIEWED]: 'bg-yellow-100 text-yellow-800',
  [QuoteStatus.ACCEPTED]: 'bg-green-100 text-green-800',
  [QuoteStatus.REJECTED]: 'bg-red-100 text-red-800',
  [QuoteStatus.EXPIRED]: 'bg-orange-100 text-orange-800',
  [QuoteStatus.CONVERTED]: 'bg-purple-100 text-purple-800',
  [QuoteStatus.PENDING]: 'bg-orange-100 text-orange-800',
  [QuoteStatus.CANCELLED]: 'bg-gray-100 text-gray-800',
} as const;






